const InvestmentsChallenge2Dataset = {
        items: {
            "item-1": { id: "item-1", content: "May give you voting rights, prices can have significant " +
                    " price fluctuations may pay dividends.",
                    answer: "column-3"},
            "item-2": { id: "item-2", content: "A diversified mix of investments managed by professionals.", 
                    answer: "column-2"}, 
            "item-3": { id: "item-3", content: "Loans made to governments or businesses, set maturity date, can be paid off early.", 
                    answer: "column-5"}, 
            "item-4": { id: "item-4", content: "Involves buying property and can provide rental income or long-term value growth.", 
                    answer: "column-4"}, 
        },
        columns: {
            "column-1": { id: "column-1", title: "Investment Characteristics", 
                itemIds: ['item-1', 'item-2', 'item-3', "item-4"] },
            "column-2": { id: "column-2", title: "Mutual Funds", itemIds: [] },
            "column-3": { id: "column-3", title: "Stocks", itemIds: [] },
            "column-4": { id: "column-4", title: "Real Estate", itemIds: [] },
            "column-5": { id: "column-5", title: "Bonds", itemIds: [] },
                  
        },
        columnOrder: ["column-1", "column-2", "column-3", "column-4", "column-5"]
    }

export default InvestmentsChallenge2Dataset